
    var riot = require('riot')
    //src: starling/src/tags/modal-extensions.html
riot.tag2('modal-extensions',
  '<div if="{isVisible}" class="Modal Modal--locked Modal--tall" onclick="{stopPropagation}"> <header class="Modal_header Modal_header--alt Modal_header--subtitled"> <div class="Modal_header_content"> <h2 class="Modal_title Modal_title--small"> Add-ons </h2> <p class="Modal_header_subtitle">Do more with Plectica using powerful add-ons to support your workflow!</p> </div> <button class="Button Button--Plain Button--Icon Button--Round" onclick="{dismiss}"> <svg class="Button__Icon"> <use xlink:href="#close-icon"></use> </svg> </button> </header> <div class="Modal_body Modal_body--padded" onwheel="{stopPropagation}"> <add-on-panel each="{addOns}"></add-on-panel> </div> </div>',
  '',
  'class="Modal_overlay" show="{isVisible}" onclick="{dismiss}"', function(opts) {
'use strict';

var _this = this;

var _opts = opts,
    canvas = _opts.canvas;
var operation = canvas.operation;

canvas.extensionsModal = this;

this.addOns = [{
  name: 'perspectives',
  title: 'Perspectives',
  icon: 'visibility',
  description: 'Explain cards from alternative points-of-view.'
}, {
  name: 'attributes',
  title: 'Tags',
  icon: 'tags',
  description: 'Add more informational detail about cards.'
}, {
  name: 'presentation',
  title: 'Slides',
  icon: 'airplay',
  description: 'Make walk-through presentations of your map.'
}, {
  name: 'comments',
  title: 'Comments',
  icon: 'comment-text-outline',
  description: 'Discuss your ideas with collaborators.'
}, {
  name: 'recent_activity',
  title: 'Recent Activity',
  icon: 'history',
  description: 'Find what’s changed in a map and playback your mapping process.'
}];

this.stopPropagation = function (e) {
  return e.stopPropagation();
};

this.show = function () {
  return _this.update({ isVisible: true });
};

this.dismiss = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _this.update({ isVisible: false });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-extensions')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-extensions.html
// module id = 638
// module chunks = 0